<div class="mobile-menu-bar">
  <div class="mobile-menu-bar-content">
    <div
      class="mobile-menu-bar-entry"
      role="button"
      routerLink="/">

      <i class="pi pi-home"></i>
    </div>

    <div
      class="mobile-menu-bar-entry"
      role="button"
      routerLink="/">

      <i class="pi pi-search"></i>
    </div>

    <div
      class="mobile-menu-bar-entry"
      role="button"
      routerLink="/client/add">

      <i class="pi pi-plus-circle"></i>
    </div>

    <div
      class="mobile-menu-bar-entry"
      role="button"
      routerLink="/subscription">

      <i class="pi pi-credit-card"></i>
    </div>

    <div class="mobile-menu-bar-entry"
         role="button"
         (click)="logout()">
      <i class="pi pi-sign-out"></i>
    </div>
  </div>
</div>
